import { createFeatureFlagContext, featureFlagFilters, WithSnowplow } from '@montugroup/data-collection';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { FF_ENABLE_SNOWPLOW } from '../constants/featureFlags';
import { SNOWPLOW_SETTINGS } from '../constants/snowplow';
import { getUser } from '../data/service/authService';
import { useFeatureFlags } from '../hooks';

// This component acts as a wrapper around WithSnowplow from data-collection
// It ensures the user_id field is properly set at all times
export const AuthenticatedSnowplow = (props: React.PropsWithChildren) => {
  const { children } = props;
  const { flags } = useFeatureFlags();
  const ldClient = useLDClient();
  const enableSnowplow = flags[FF_ENABLE_SNOWPLOW];
  const user = getUser();
  let userId = null;
  if (
    user &&
    user.constructor === Object &&
    user.id !== undefined &&
    user.id !== null &&
    ['string', 'number'].includes(typeof user.id)
  ) {
    try {
      userId = user.id.toString();
      console.info('The user has been set in snowplow:', userId);
    } catch (error) {
      console.error('Failed to set user in snowplow:', error);
    }
  }

  const featureFlags = (_params: { element: HTMLElement; eventType: string; value: string }) => {
    const element = _params.element.closest('[data-snowplow-tracking-group]');
    const value = element?.getAttribute('data-snowplow-tracking-group');

    if (value === 'patient-details') {
      const contexts = createFeatureFlagContext({
        ldClient,
        flags,
        filter: featureFlagFilters.includeOnly([]),
      });

      return contexts[0] || null;
    }

    return null;
  };

  return WithSnowplow(
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>,
    {
      appId: SNOWPLOW_SETTINGS.appId,
      trackerName: SNOWPLOW_SETTINGS.trackerName,
      userId: userId ?? 'unknown',
      pageViewContext: [],
      pluginsOverride: {
        formTracking: {
          enabled: true,
          config: {
            context: [featureFlags],
          },
        },
      },
    },
    enableSnowplow,
  );
};

export default AuthenticatedSnowplow;
